/**
 * Green Volt logo — uses the official brand mark.
 * Sits on a subtle white tile in dark mode so the wordmark stays legible.
 */
export function Logo() {
  return (
    <span className="inline-flex items-center justify-center rounded-md h-9">
      <img
        src={"greenvolt-logo.png"}
        alt="Green Volt"
        className="h-full w-auto object-contain"
        width={120}
        height={120}
      />
    </span>
  );
}
